import { getWeekOfMonth } from 'date-fns';
import getDay from 'modules/schedule/domain/utils/get-day';
import { ScheduleSliceState } from 'modules/schedule/store';

export function getDayFromState(state: ScheduleSliceState, date: Date) {
  const isSomeMonth = state.currentMonth !== date.getMonth();
  const isSomeYear = state.currentYear !== date.getFullYear();
  if (isSomeMonth || isSomeYear) return;
  const weekNum = getWeekOfMonth(date, { weekStartsOn: 1 });
  return state.weeks[weekNum - 1][getDay({ date: date })];
}
